module.exports = __webpack_public_path__ + "static/preview-fab-large-491e951b2a060e638ccdf348b0e40e59.jpg";